import CopyToClipboard from 'components/util/CopyToClipboard';
import { ExternalToast, toast } from 'sonner';

export type SnackOptions = {
    requestId?: string;
};

function AlertMessage({ message, requestId }: { message: string } & SnackOptions) {
    if (!requestId) {
        return <div className="new:text-foreground pl-2 text-sm font-semibold text-black">{message}</div>;
    }
    return (
        <div className="flex flex-col gap-1 pl-2">
            <div className="new:text-foreground text-sm font-semibold text-black">{message}</div>
            <div className="flex items-center text-xs text-gray-500">
                Request ID: {requestId} <CopyToClipboard text={requestId} />
            </div>
        </div>
    );
}

export function successAlert(message: string, options?: ExternalToast) {
    return toast.success(<AlertMessage message={message} />, options);
}

/**
 * An error stays until it is dismissed: it may be the only word on what failed, and it carries the request id to
 * copy, so no timer takes it away. The same message raised again replaces the toast that shows it rather than
 * stacking under it. A caller's own `duration` or `id` wins.
 */
export function errorAlert(message: string, options?: SnackOptions & ExternalToast) {
    return toast.error(<AlertMessage message={message} requestId={options?.requestId} />, {
        duration: Infinity,
        id: `error:${message}`,
        ...options,
    });
}

export function warningAlert(message: string, options?: ExternalToast) {
    return toast.warning(<AlertMessage message={message} />, options);
}

export function infoAlert(message: string, options?: ExternalToast) {
    return toast.info(<AlertMessage message={message} />, options);
}

/** Closes a toast early, by the id its alert returned. Its `onDismiss` runs. */
export const dismissAlert = (id: string | number) => toast.dismiss(id);
